import { OVERLAYS } from '@witmetrics/unison-core';
import { useAppState } from '@/providers/AppStateProvider';
import AgendaOverlay from '@/overlays/AgendaOverlay';

const { AGENDA } = OVERLAYS;

export default function OverlaysManager() {
  const { activeOverlays, onCloseOverlay } = useAppState();

  return (
    <>
      {activeOverlays[AGENDA] && (
        <AgendaOverlay onClose={() => onCloseOverlay(AGENDA)} />
      )}
    </>
  );
}
